var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t(
          "Webheader.connector_list_" +
            _vm.entitiesType +
            "_" +
            _vm.role +
            "_" +
            _vm.type
        ),
        "show-refresh": true,
        "refresh-disabled": _vm.activateSpinner,
      },
      on: { refresh: _vm.onRefresh },
      scopedSlots: _vm._u([
        {
          key: "primaryActions",
          fn: function () {
            return [
              _c("app-button", {
                attrs: {
                  text: _vm.$t("common.bck"),
                  icon: "fa-light fa-arrow-left",
                  variant: "primary",
                  returnUrl: _vm.returnUrl,
                  isBackButton: true,
                  "aria-label": _vm.$t("common.bck"),
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { staticClass: "listPage", attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start" },
                [
                  _vm.canGetVopProvider && _vm.entitiesType == "rvm"
                    ? _c(
                        "b-col",
                        { attrs: { cols: "6", lg: "3", xl: "3" } },
                        [
                          _c("app-button", {
                            attrs: {
                              text: _vm.$t(
                                "common.routing.consult_list_vop_provider"
                              ),
                              variant: "primary",
                              block: true,
                              "custom-class":
                                "mr-3 justify-item-end responsive-button",
                            },
                            on: { click: _vm.getVopProvider },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "b-tabs",
                {
                  attrs: {
                    value: _vm.role == 0 ? 1 : 0,
                    "nav-class": "d-none",
                  },
                },
                [
                  _c(
                    "b-tab",
                    {
                      class: _vm.role == 0 ? "d-none" : "",
                      attrs: { title: _vm.$t("common.routing.receiver") },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-tabs",
                            {
                              staticClass: "p-3 w-100",
                              attrs: { "content-class": "mt-3" },
                              model: {
                                value: _vm.tabIndex,
                                callback: function ($$v) {
                                  _vm.tabIndex = $$v
                                },
                                expression: "tabIndex",
                              },
                            },
                            [
                              _c(
                                "b-tab",
                                { attrs: { title: "WebService" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.webServiceCredentialList
                                                .length > 0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items:
                                                        _vm.webServiceCredentialList,
                                                      fields:
                                                        _vm.webServiceCredentialFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeWebServiceCredentialDetails,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "cell(Active)",
                                                          fn: function (data) {
                                                            return [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    data.value ===
                                                                      "1"
                                                                      ? _vm.$t(
                                                                          "common.routing.yes"
                                                                        )
                                                                      : _vm.$t(
                                                                          "common.routing.no"
                                                                        )
                                                                  ) +
                                                                  "\n                    "
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      2671043125
                                                    ),
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                { attrs: { title: "MqSeries" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.mqseriesCredentialList
                                                .length > 0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items:
                                                        _vm.mqseriesCredentialList,
                                                      fields:
                                                        _vm.mqseriesCredentialFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeMQSeriesCredentialDetails,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "cell(Active)",
                                                          fn: function (data) {
                                                            return [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    data.value ===
                                                                      "1"
                                                                      ? _vm.$t(
                                                                          "common.routing.yes"
                                                                        )
                                                                      : _vm.$t(
                                                                          "common.routing.no"
                                                                        )
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                        {
                                                          key: "cell(idEngine)",
                                                          fn: function (data) {
                                                            return [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.$engine.get(
                                                                      data.value
                                                                    ).common
                                                                      .network
                                                                      .info.name
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      2549855080
                                                    ),
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: _vm.$t("common.routing.ftp"),
                                  },
                                },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.FTPCredentialList.length > 0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items:
                                                        _vm.FTPCredentialList,
                                                      fields: _vm.FTPFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeFTPCredentialDetails,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      class: _vm.role == 1 ? "d-none" : "",
                      attrs: { title: _vm.$t("common.routing.responder") },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-tabs",
                            {
                              staticClass: "p-3 w-100",
                              attrs: { "content-class": "mt-3" },
                              model: {
                                value: _vm.tabIndex,
                                callback: function ($$v) {
                                  _vm.tabIndex = $$v
                                },
                                expression: "tabIndex",
                              },
                            },
                            [
                              _c(
                                "b-tab",
                                { attrs: { title: "WebService" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.webServiceConfigList.length >
                                              0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items:
                                                        _vm.webServiceConfigList,
                                                      fields:
                                                        _vm.webServiceConfigFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeWebServiceConfigDetails,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "cell(Active)",
                                                          fn: function (data) {
                                                            return [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    data.value ===
                                                                      "1"
                                                                      ? _vm.$t(
                                                                          "common.routing.yes"
                                                                        )
                                                                      : _vm.$t(
                                                                          "common.routing.no"
                                                                        )
                                                                  ) +
                                                                  "\n                    "
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      2671043125
                                                    ),
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                { attrs: { title: "MqSeries" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.mqseriesConfigList.length > 0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped table-hover",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items:
                                                        _vm.mqseriesConfigList,
                                                      fields:
                                                        _vm.mqseriesFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeMQSeriesDetails,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "cell(Active)",
                                                          fn: function (data) {
                                                            return [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    data.value ===
                                                                      "1"
                                                                      ? _vm.$t(
                                                                          "common.routing.yes"
                                                                        )
                                                                      : _vm.$t(
                                                                          "common.routing.no"
                                                                        )
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                        {
                                                          key: "cell(idEngine)",
                                                          fn: function (data) {
                                                            return [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.$engine.get(
                                                                      data.value
                                                                    ).common
                                                                      .network
                                                                      .info.name
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      2549855080
                                                    ),
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: _vm.$t("common.routing.ftp"),
                                  },
                                },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.FTPConfigList.length > 0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items: _vm.FTPConfigList,
                                                      fields: _vm.FTPFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeFTPConfigDetails,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.configType !== "INTERPROCESS" && _vm.canAddConfig
                ? _c(
                    "b-row",
                    { staticClass: "justify-content-end mt-3 no-gutters" },
                    [
                      _c("app-button", {
                        attrs: {
                          text: _vm.$t("common.routing.add_config"),
                          icon: "fa-light fa-plus",
                          variant: "primary",
                        },
                        on: { click: _vm.addConfig },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }